import React, { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Toggle } from 'core/hoc';
import {
	Content,
	ShowMore,
	TextButton,
} from 'core/styles';
import loadable from '@loadable/component';
import styled from 'styled-components';

const SvgPlaceholder = styled.div`
	width: 18px;
	height: 18px;
`;
const OneBox = loadable(() => import('core/icons/OneBox'), { fallback: <SvgPlaceholder /> });
const Truck = loadable(() => import('core/icons/Truck'), { fallback: <SvgPlaceholder /> });
const Renew = loadable(() => import('core/icons/Renew'), { fallback: <SvgPlaceholder /> });

const ShippingBullet = styled.div`
	display: grid;
	margin: 16px 8px 8px 0;
	grid-template-columns: 30px calc(100% - 30px);
	svg {
		align-self: center;
		margin: 0 8px 0 0;
	}
`;

const ShippingRestrictions = ({
	type,
	shipCountry,
	onShowModal,
}) => {
	if (type === 'worldwide') {
		return (<span>{`Ships worldwide from ${shipCountry}`}</span>);
	}
	if (type === 'domestic') {
		return (<span>{`Only ships within ${shipCountry}`}</span>);
	}
	if (type === 'select') {
		return (
			<span>
				Ships to <TextButton isBlue onClick={onShowModal}>select countries</TextButton> from {shipCountry}
			</span>
		);
	}
	if (type === 'restricted') {
		return (
			<span>
				Ships worldwide from {shipCountry} except for <TextButton isBlue onClick={onShowModal}>select countries</TextButton>
			</span>
		);
	}
	return null;
};

class ShippingDetails extends PureComponent {
	render() {
		const {
			initialShipmentString,
			subsequentShipmentDescription,
			renewalString,
			description,
			restrictions,
			visibleWordCount,
			openShipList,
			hideShipsBy,
		} = this.props;

		const hasStructuredShipping = initialShipmentString && subsequentShipmentDescription && renewalString;

		if (!description && !hasStructuredShipping) return null;

		const words = description ? description.split(' ') : [];
		const hasMore = words.length > visibleWordCount;

		return (
			<Fragment>
				<Toggle simple>
					{({ on, toggle }) => {
						let body = description;
						if (!on && hasMore) {
							body = words.filter((_, i) => i < visibleWordCount).join(' ');
							body += '...';
						}

						return (
							<Fragment>
								<Content as="div">
									{hasStructuredShipping && <>
										{!hideShipsBy && <ShippingBullet><OneBox /><div>{initialShipmentString}</div></ShippingBullet>}
										<ShippingBullet><Truck /><div>{subsequentShipmentDescription}</div></ShippingBullet>
										<ShippingBullet><Renew /><div>{renewalString}</div></ShippingBullet>
										<ShippingBullet />
									</>}
									{body}
									{' '}
									{(!on && hasMore) && (
										<ShowMore onClick={toggle}>
											Show More
										</ShowMore>
									)}
								</Content>
								{ (on && hasMore) && (
									<Content>
										<ShippingRestrictions
											{...restrictions}
											onShowModal={openShipList}
										/>
										<br />
										<ShowMore onClick={toggle}>
											Show Less
										</ShowMore>
									</Content>
								)}
							</Fragment>
						);
					}}
				</Toggle>
			</Fragment>
		);
	}
}

ShippingRestrictions.propTypes = {
	type: PropTypes.string,
	shipCountry: PropTypes.string,
	onShowModal: PropTypes.func,
};

ShippingDetails.propTypes = {
	description: PropTypes.string,
	initialShipmentString: PropTypes.string,
	subsequentShipmentDescription: PropTypes.string,
	renewalString: PropTypes.string,
	restrictions: PropTypes.object,
	visibleWordCount: PropTypes.number,
	openShipList: PropTypes.func,
	hideShipsBy: PropTypes.bool,
};

ShippingDetails.defaultProps = {
	description: "",
	restrictions: {},
	visibleWordCount: 28,
	hideShipsBy: false,
	openShipList: () => null,
};

export default ShippingDetails;
